module.exports = __webpack_public_path__ + "media/images/front/centres/showroom_onda-3027c9d44f30b4c598efa4d3dc1722e6.jpg";